module.exports = __webpack_public_path__ + "static/img/1.bda7055.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/1.png
// module id = umYu
// module chunks = 0